import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { faInfo, faFileExclamation } from '@fortawesome/pro-solid-svg-icons';
import { faCircle } from '@fortawesome/free-regular-svg-icons';
import { Accordion } from 'react-bootstrap';
import { faCircleCheck, faCircleMinus } from '@fortawesome/pro-duotone-svg-icons';
import { useState } from 'react';
import { useGetSearchQuestionPropertiesMutation } from '../../../../../../../features/authentication/questionSearchApiSlice';
import CustomToast from '../../../../../../../components/Toast';
import QuestionPropertiesModal from '../../QuestionPropertiesModal';
import { faSquareCheck, faSquare } from '@fortawesome/pro-solid-svg-icons';
import Modal from '../../../../../../../components/Modal/index';
import { useAssignmentContext } from '../../../../../../../pages/assignments/context';
import AssignmentsUsedBy from '../../../../AssignmentsUsedBy';

const QuestionThumbnail = ({ questionDetails, selectedQuestions, setSelectedQuestions, removeOnly, setDateBasedKey }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [propertiesResult, setPropertiesResult] = useState({});
  const [getQuestionPropertiesCall] = useGetSearchQuestionPropertiesMutation();
  const [showQuestionPropertiesModal, setShowQuestionPropertiesModal] = useState(false);
  const [questionModalDetails, setQuestionModalDetails] = useState({});
  const [showUsedByModal, setShowUsedByModal] = useState(false);
  const [showQuestionModal, setShowQuestionModal] = useState(false);
  const { setHasPendingChanges } = useAssignmentContext();
  const handleGetQuestionProperties = async (e, question) => {
    setIsLoading(true);
    e?.stopPropagation();
    setShowQuestionPropertiesModal(true);

    if (question.questionId == propertiesResult.data?.questionId) return;

    const options = {
      questionId: question.questionId,
      questionSource: question.questionSource
    };
    const response = await getQuestionPropertiesCall(options);
    if (response.error) {
      CustomToast('Could not get question properties', 'error');
      setShowQuestionPropertiesModal(false);
    }
    else {
      setPropertiesResult(response);
    }
    setIsLoading(false);
  };

  const handleSelectQuestion = (questionDetails, e) => {
    e.stopPropagation();
    if (!questionDetails.isSelected && selectedQuestions.length >= 100) {
      CustomToast('You have already reached the maximum number of questions', 'error');
      return;
    }

    questionDetails.isSelected = !questionDetails.isSelected;
    if (questionDetails.isSelected) {
      setSelectedQuestions([...selectedQuestions, questionDetails]);
      setHasPendingChanges(true);
    } else {
      setSelectedQuestions(selectedQuestions.filter(q => `${q.questionType}${q.questionId}` != `${questionDetails.questionType}${questionDetails.questionId}`));
      setHasPendingChanges(selectedQuestions.filter(q => `${q.questionType}${q.questionId}` != `${questionDetails.questionType}${questionDetails.questionId}` && !q.inAssignment).length > 0);
    }
    setDateBasedKey(new Date().getTime().toString());
  };

  const handleGetUsedByDetails = (e) => {
    e.stopPropagation();
    setShowUsedByModal(true);
  };

  const handlePlayVideo = (e, videoId) => {
    e.stopPropagation();
    var videoButton = document.getElementById(`videoButton${videoId}`);
    var videoPlayer = document.getElementById(`video${videoId}`);
    var showVideo = videoPlayer.style.display == 'none';

    if (!showVideo) videoPlayer.pause();
    videoButton.innerHTML = showVideo ? 'Hide video' : 'Show video';
    videoPlayer.style.display = showVideo ? 'inline-block' : 'none';
  };

  return (
    <>
      <div className='questionThumbnail cursor-pointer' onClick={() => !questionDetails.blockedText && (setQuestionModalDetails(questionDetails), setShowQuestionModal(true))}>
        <div className='buttonContainer' >
          <div className='topBtnsContainer'>
            {questionDetails.blockedText == null &&
              <div className='editInfoBtn' onClick={(e) => handleGetQuestionProperties(e, questionDetails)}>
                <FontAwesomeIcon style={{ fontSize: '16px' }} icon={faInfo} />
                <div className='editInfoDescription'>Properties</div>
              </div>
            }

            {/* <OverlayTrigger
              key={`addedit_${questionDetails.questionId}`}
              placement="top"
              overlay={
                <Tooltip id="45824582" className="custom-tooltip">
                  <p className="mb-0">Coming Soon!</p>
                </Tooltip>
              }>
              <div className='editInfoBtn mt-3' onClick={(e) => e.stopPropagation()}>
                <FontAwesomeIcon style={{ fontSize: '16px' }} icon={faPencil} />
                <div className='editInfoDescription' >Edit-Add</div>
              </div>
            </OverlayTrigger> */}

            {questionDetails?.usedBy?.length > 0 &&
              <div className='editInfoBtn mt-3' onClick={(e) => handleGetUsedByDetails(e)}>
                <FontAwesomeIcon style={{ fontSize: '16px' }} icon={faFileExclamation} />
                <div className='editInfoDescription'>Used in an assignment</div>
              </div>
            }
          </div>

          <div className='selectBtns'>
            <div className='d-flex flex-row justify-content-between'>
              {/* <div className='questionThumbnailButtons' style={{ background: '#EDF5FF' }}><FontAwesomeIcon color='#82A9E2' style={{ fontSize: '16px' }} icon={faLink} /></div> */}
              {/* Below is place holder for Link - Uncomment line above for link icon */}
              <div style={{ height: '30px', width: '30px' }}></div>
              {questionDetails.inAssignment &&
                <div className='questionThumbnailButtons' style={{ cursor: 'default' }} onClick={(e) => { e.stopPropagation(); }}>
                  <OverlayTrigger
                    key="editToolTip"
                    placement="top"
                    overlay={<Tooltip className="custom-tooltip">Question in assignment</Tooltip>}>
                    <FontAwesomeIcon style={{ '--fa-primary-color': '#FFFFFF', '--fa-secondary-color': (removeOnly ? '#F79E9E' : '#9EDBC9'), '--fa-secondary-opacity': '1' }} icon={removeOnly ? faCircleMinus : faCircleCheck} />
                  </OverlayTrigger>
                </div>
              }

              {!questionDetails.inAssignment && !questionDetails.blockedText &&
                <div className='questionThumbnailButtons' onClick={(e) => { handleSelectQuestion(questionDetails, e); }}>
                  {questionDetails.isSelected ?
                    <OverlayTrigger
                      key="editToolTip"
                      placement="top"
                      overlay={<Tooltip className="custom-tooltip">Unselect Question</Tooltip>}>
                      <FontAwesomeIcon style={{ '--fa-primary-color': '#FFFFFF', '--fa-secondary-color': (removeOnly ? '#F84646' : '#52C9A5'), '--fa-secondary-opacity': '1' }} icon={removeOnly ? faCircleMinus : faCircleCheck} />
                    </OverlayTrigger>
                    :
                    <OverlayTrigger
                      key="editToolTip"
                      placement="top"
                      style={{ zIndex: 10 }}
                      overlay={<Tooltip className="custom-tooltip">Select Question</Tooltip>}>
                      <FontAwesomeIcon color='#d4deff' icon={faCircle} />
                    </OverlayTrigger>
                  }
                </div>
              }
            </div>
          </div>
        </div>
        <div className='d-flex flex-column overflow-hidden' style={{ height: '84%' }} >
          <div style={{ fontSize: '0.85em' }}>{`ID: ${questionDetails.questionSource ? questionDetails.questionSource : ''}${questionDetails.questionId}`}</div>
          <div style={{ fontSize: '0.85em' }}>{!questionDetails.blockedText && `${questionDetails.answer ? `Answer: ${questionDetails.answer}` : ''} [Level: ${questionDetails.level}, Correct: ${questionDetails.correct}, Incorrect: ${questionDetails.incorrect}]`}</div>
          <div className='my-1' style={{ border: '1px solid #E7EDFF' }}></div>
          {questionDetails.resources?.length >= 1 &&
            <div className='mb-3'>
              {questionDetails.resources.map((resource, index) => {

                if (resource.description.toLowerCase().includes('document missing')) {
                  return (
                    <div key={`docMissing${index}`} className='text-danger'>{resource.description}</div>
                  );
                }

                return (
                  <>
                    
                    {resource.selectionTitle &&
                      <Accordion key={`resource${index}`}>
                        <Accordion.Header><div dangerouslySetInnerHTML={resource.selectionTitle === 'Reading Selection' ? { __html: resource.selectionTitle +' '+ (index + 1) }:{ __html: resource.selectionTitle }}></div></Accordion.Header>
                        <Accordion.Body>
                          <div dangerouslySetInnerHTML={{ __html: resource.description }}></div>
                        </Accordion.Body>
                      </Accordion>
                    }

                    {!resource.selectionTitle && 
                          <div dangerouslySetInnerHTML={{ __html: resource.description }}></div>
                    }
                    
                    {resource.imagePath &&
                          <img src={resource.imagePath }></img>
                    }
                    {!resource.selectionTitle && resource.mp3Path &&
                      <div className='d-flex flex-column'>
                        {resource.description && <div className='border-black p-1' dangerouslySetInnerHTML={{ __html: resource.description }}></div>}
                        {resource.mp3Path && <audio style={{ maxWidth: '98%' }} controls='controls' src={resource.mp3Path} type='audio/mpeg' ></audio>}
                      </div>}

                    {!resource.selectionTitle && resource.mp4Path &&
                      <div style={{ border: '1px solid black', padding: '5px', width: '75%' }}>
                        This question contains a video.  Click to view.
                      </div>
                    }
                  </>
                );
              })}
            </div>
          }

          {questionDetails.blockedText ?
            <div className='text-danger fw-semibold fs-6' dangerouslySetInnerHTML={{ __html: questionDetails.blockedText }}></div>
            :
            <>
              {questionDetails.question &&
                <div dangerouslySetInnerHTML={{ __html: questionDetails.question }}></div>
              }

              {questionDetails.sampleAnswer ?
                <>
                  <div className='mt-2 mb-1 fw-bold'>Sample Answer</div>
                  <div dangerouslySetInnerHTML={{ __html: questionDetails.sampleAnswer }}></div>
                </> : <></>}
            </>
          }
        </div>
      </div>

      {showQuestionPropertiesModal &&
        <QuestionPropertiesModal
          setShowQuestionPropertiesModal={setShowQuestionPropertiesModal}
          showQuestionPropertiesModal={showQuestionPropertiesModal}
          propertiesResult={propertiesResult}
          setPropertiesResult={setPropertiesResult}
          isSearchQuestion={true}
          handleSelectQuestion={handleSelectQuestion}
          questionModalDetails={questionDetails}
          isLoading={isLoading}
        />
      }

      <AssignmentsUsedBy
        usedAssignments={questionDetails.usedBy}
        showUsedByModal={showUsedByModal}
        setShowUsedByModal={setShowUsedByModal}
      />

      <Modal
        isOpen={showQuestionModal}
        onClose={() => setShowQuestionModal(false)}
        titleName='Question Details'
        contentWidth='60%'>
        <div className='d-flex flex-column'>
          <div className='d-flex flex-row justify-content-between align-items-center mb-3'>
            <span>{`ID: ${questionModalDetails.questionSource}${questionModalDetails.questionId}`}</span>
            <div className='d-flex flex-row'>
              <span>{`[Level: ${questionModalDetails.level}, Correct: ${questionModalDetails.correct}, Incorrect: ${questionModalDetails.incorrect}]`}</span>
              {questionModalDetails.answer &&
                <>
                  <span className='mx-3' style={{ border: '1px solid #8c8c8c33' }}></span>
                  <span style={{ color: '#52C9A5', fontWeight: '500' }}>{`Answer: ${questionModalDetails.answer}`}</span>
                </>}
            </div>
          </div>
          {questionModalDetails.resources?.length >= 1 &&

            <div className='mb-3'>
              {questionModalDetails.resources.map((resource, index) => {

                if (resource.description.toLowerCase().includes('document missing')) {
                  return (
                    <div key={index} className='text-danger'>{resource.description}</div>
                  );
                }

                return (
                  <>
                    {resource.selectionTitle &&
                      <Accordion key={`resource${index}`}>
                        <Accordion.Header><div dangerouslySetInnerHTML={resource.selectionTitle === 'Reading Selection' ? { __html: resource.selectionTitle +' '+ (index + 1) }:{ __html: resource.selectionTitle }}></div></Accordion.Header>
                        <Accordion.Body>
                          <div dangerouslySetInnerHTML={{ __html: resource.description }}></div>
                        </Accordion.Body>
                      </Accordion>
                    }

                    {!resource.selectionTitle && 
                          <div dangerouslySetInnerHTML={{ __html: resource.description }}></div>
                    }

                    {resource.imagePath &&
                          <img src={resource.imagePath }></img>
                    }
                    {!resource.selectionTitle && resource.mp3Path &&
                      <div className='d-flex flex-column'>
                        {resource.description && <div className='border-black p-1' dangerouslySetInnerHTML={{ __html: resource.description }}></div>}
                        {resource.mp3Path && <audio style={{ maxWidth: '98%' }} controls='controls' src={resource.mp3Path} type='audio/mpeg' ></audio>}
                      </div>}

                    {!resource.selectionTitle && resource.mp4Path &&
                      <div className='d-flex flex-column'>
                        <video id={`video${index}`} controls className='mb-2' src={resource.mp4Path} type='video/mp4' />
                        <Button variant='castleWhite' id={`videoButton${index}`} onClick={(e) => handlePlayVideo(e, index)}>Hide Video</Button>
                      </div>
                    }
                  </>
                );
              })}
            </div>}

          {(questionModalDetails.questionType != 1 || !questionModalDetails.mcAnswers || questionModalDetails.mcAnswers.length <= 0) && <div dangerouslySetInnerHTML={{ __html: questionModalDetails.question }}></div>}
          {questionModalDetails.questionType === 1 && questionModalDetails.mcAnswers?.length >= 1 &&
            <div className='d-flex flex-column'>
              <div className='mb-2' dangerouslySetInnerHTML={{ __html: questionModalDetails.mcQuestion }}></div>
              {questionModalDetails.mcAnswers.map((item, index) => {
                return (
                  <div className={`d-flex flex-row align-items-center mb-2 mcAnswer ${item.correct === 1 ? 'correct' : ''}`} key={`mcAnswer_${index}`}>
                    {item.correct === 1 && <FontAwesomeIcon color='#52C9A5' icon={faSquareCheck} />}
                    {item.correct != 1 && <FontAwesomeIcon color='#F3F5F9' icon={faSquare} />}

                    <div className='mx-2' id={`mcAnswer_${index}_label`}>{`${index + 1}.`}</div>
                    <div dangerouslySetInnerHTML={{ __html: item.answer }}></div>
                  </div>
                );
              })}
            </div>}

          {questionModalDetails.sampleAnswer &&
            <Accordion>
              <Accordion.Header>Sample Answer</Accordion.Header>
              <Accordion.Body>
                <div dangerouslySetInnerHTML={{ __html: questionModalDetails.sampleAnswer }}></div>
              </Accordion.Body>
            </Accordion>
          }
          <div className='d-flex flex-row justify-content-end'>
            <Button className='mt-3' variant='castleRed' style={{ width: '15%' }} disabled={questionModalDetails.inAssignment} onClick={(e) => { handleSelectQuestion(questionModalDetails, e); setShowQuestionModal(false); }}>{`${questionModalDetails.isSelected ? 'Unselect Question' : 'Select Question'}`}</Button>
          </div>
        </div>
      </Modal>
    </>
  );
};

QuestionThumbnail.propTypes = {
  questionDetails: PropTypes.object.isRequired,
  defaultChecked: PropTypes.bool,
  selectedQuestions: PropTypes.array,
  setSelectedQuestions: PropTypes.func,
  removeOnly: PropTypes.bool,
  setDateBasedKey: PropTypes.func
};

export default QuestionThumbnail;